<script>
  import Footer from "../Components/Footer.svelte";
  import Title from "../Components/Title.svelte";
  import { useFocus } from "svelte-navigator";
  const focus = useFocus();
</script>

<svelte:head>
  <meta
    name="description"
    content="Contact Country Cruel for booking or to get in touch."
  />
  <title>Contact - Country Cruel</title>
</svelte:head>
<h2 use:focus>Contact</h2>
<main>
  <p>
    For booking or other information contact Ernie Renn at
    <a href='mailto:countrycruelband@gmail.com'>countrycruelband@gmail.com</a>
  </p>
  <Title />

</main>
<Footer />

<!-- href="mailto:drinkemcountrycool@gmail.com" -->